import {cn} from "@/lib/utils";
import type {ReactNode} from "react";
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from "@/components/ui/dialog.tsx";

type Props = {
  title: string,
  children: ReactNode,
  className?: string,
  onClose?: () => void,
  onLoad?: (node: HTMLDivElement) => void,
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl",
  hideTitle?: boolean,
}
export function AppDialog({title, children, onClose, className, onLoad, hideTitle = false, size = 'md'}: Props)  {
  return (
    <Dialog open={true} onOpenChange={(open: boolean) => {
      if (!open && onClose) {
        onClose();
      }
    }}>
      <DialogContent className={cn(
        "app-dialog overflow-y-auto max-h-screen ", `size-${size}`, className)
      } ref={(node: HTMLDivElement) => {
        if (onLoad && node) {
          onLoad(node);
        }
      }}>
        <DialogHeader>
          <DialogTitle className={cn(hideTitle && 'hidden')}>{title}</DialogTitle>
          <DialogDescription className="hidden">{title}</DialogDescription>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}